import React from 'react';
import {
  AppBadge,
  AppButton,
  AppFormField,
  AppInput,
  AppModal,
  AppTextarea,
} from '../../ui';

function KlubMagazineOffreEditModal({
  show,
  busy,
  form,
  onChangeForm,
  onClose,
  onSave,
}) {
  return (
    <AppModal
      show={show}
      title="Éditer le snapshot offre"
      onClose={onClose}
      size="lg"
      footer={(
        <>
          <AppButton variant="outline-secondary" onClick={onClose}>Annuler</AppButton>
          <AppButton variant="primary" loading={busy} onClick={onSave}>Enregistrer</AppButton>
        </>
      )}
    >
      <div className="row g-3">
        <div className="col-12">
          <AppBadge
            as="button"
            type="button"
            id="offre-nouveau"
            variant={form.is_nouveau ? 'success' : 'secondary'}
            pill
            className={`klub-magazine-nouveau-tag${form.is_nouveau ? ' is-active' : ''}`}
            aria-pressed={form.is_nouveau}
            onClick={() => onChangeForm((f) => ({ ...f, is_nouveau: !f.is_nouveau }))}
          >
            Nouveau
          </AppBadge>
        </div>
        <div className="col-md-6">
          <AppFormField label="Libellé commerçant" htmlFor="offre-label">
            <AppInput id="offre-label" value={form.commercant_label} onChange={(e) => onChangeForm((f) => ({ ...f, commercant_label: e.target.value }))} />
          </AppFormField>
        </div>
        <div className="col-md-6">
          <AppFormField label="À partir de" htmlFor="offre-apartirde">
            <AppInput id="offre-apartirde" value={form.apartirde} onChange={(e) => onChangeForm((f) => ({ ...f, apartirde: e.target.value }))} />
          </AppFormField>
        </div>
        <div className="col-12">
          <AppFormField label="Description" htmlFor="offre-desc">
            <AppTextarea id="offre-desc" rows={3} value={form.description} onChange={(e) => onChangeForm((f) => ({ ...f, description: e.target.value }))} />
          </AppFormField>
        </div>
        <div className="col-md-4">
          <AppFormField label="Remise" htmlFor="offre-remise">
            <AppInput id="offre-remise" type="number" step="0.01" value={form.remise} onChange={(e) => onChangeForm((f) => ({ ...f, remise: e.target.value }))} />
          </AppFormField>
        </div>
        <div className="col-md-4">
          <AppFormField label="Prix" htmlFor="offre-prix">
            <AppInput id="offre-prix" type="number" step="0.01" value={form.prix} onChange={(e) => onChangeForm((f) => ({ ...f, prix: e.target.value }))} />
          </AppFormField>
        </div>
        <div className="col-md-4">
          <AppFormField label="Prix barré" htmlFor="offre-prix-barre">
            <AppInput id="offre-prix-barre" type="number" step="0.01" value={form.prix_barre} onChange={(e) => onChangeForm((f) => ({ ...f, prix_barre: e.target.value }))} />
          </AppFormField>
        </div>
        <div className="col-12">
          <AppFormField label="Copyright" htmlFor="offre-copyright">
            <AppInput id="offre-copyright" value={form.copyright} onChange={(e) => onChangeForm((f) => ({ ...f, copyright: e.target.value }))} />
          </AppFormField>
        </div>
      </div>
    </AppModal>
  );
}

export default KlubMagazineOffreEditModal;
